import * as React from "react";
const SvgFiBrandsImdb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M22.628 6.126H1.371C.615 6.126 0 6.742 0 7.498v9.003c0 .757.615 1.372 1.371 1.372h21.257c.756 0 1.372-.615 1.372-1.372V7.498c0-.756-.615-1.372-1.372-1.372m0 .243c.624 0 1.129.505 1.129 1.129v9.003c0 .625-.504 1.129-1.129 1.129H1.371a1.13 1.13 0 0 1-1.129-1.129V7.498c0-.624.505-1.129 1.129-1.129z"
      clipRule="evenodd"
    />
    <path fill="#151A2D" d="M5.232 8.614H3.456v6.85h1.776z" />
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="m9.022 8.614-.412 3.202-.252-1.74a49 49 0 0 0-.215-1.462H5.84v6.85h1.557l.007-4.522.654 4.523h1.11l.623-4.623.003 4.623h1.553V8.614zM14.124 9.85q.105.059.136.193.03.13.03.594v2.653q0 .688-.09.84-.09.155-.471.153V9.787q.29 0 .395.063m-.016 5.616q.638 0 .956-.07a1.2 1.2 0 0 0 .53-.246.9.9 0 0 0 .303-.485q.091-.31.093-1.232v-2.404c0-.648-.027-1.083-.063-1.305a1.2 1.2 0 0 0-.3-.601q-.234-.27-.69-.39c-.302-.08-.8-.12-1.66-.12h-1.325v6.852zM18.908 13.805q0 .495-.05.627c-.033.087-.176.129-.286.129q-.159.002-.212-.126-.051-.125-.053-.578v-1.81q0-.466.047-.585.05-.115.206-.116c.11 0 .255.047.292.133q.055.135.056.568zm-2.314-5.191v6.85h1.6l.113-.434c.143.176.302.305.478.395.176.086.435.129.637.129a1.2 1.2 0 0 0 .727-.222q.31-.22.389-.522.084-.303.083-.917V11.97q.002-.622-.027-.81a.92.92 0 0 0-.558-.698 1.6 1.6 0 0 0-.614-.11c-.202 0-.465.04-.64.123a1.4 1.4 0 0 0-.475.365V8.614z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsImdb;
